import Icon from '../../forms/icon.component';

interface PaginationProps {
  currentPage: number;
  rowsPerPage: number;
  totalRows: number;
  isFirst: boolean;
  isLast: boolean;
  onRowsPerPageChange: (v: number) => void;
  onChange: (action: 'first' | 'prev' | 'next' | 'last') => void;
  labelOf?: string;
}

const getIconProps = (disabled: boolean) => ({
  size: disabled ? 'fs-4' : 'fs-3',
  type: disabled ? 'muted' : 'dark'
});

export function Pagination({
  currentPage,
  rowsPerPage,
  totalRows,
  isFirst,
  isLast,
  onRowsPerPageChange,
  onChange,
  labelOf
}: PaginationProps) {
  const ofLabel = labelOf || 'de';
  const from = currentPage * rowsPerPage + 1;
  const to = Math.min((currentPage + 1) * rowsPerPage, totalRows);

  return (
    <nav className="bg-light b-radius-i bg-dtt p-3">
      <div className="d-flex flex-wrap align-items-center">
        {/* LEFT */}
        <div className="d-flex align-items-center gap-2 w-100 w-md-auto">
          <select
            className="form-select form-select-sm w-auto form-select-solid bg-light"
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(+e.target.value)}
          >
            {[10, 15, 20, 25, 30, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>

          <span className="fw-bolder text-nowrap">registros</span>
        </div>

        {/* ================= MOBILE ================= */}

        {/* MOBILE contador (derecha, misma fila) */}
        <div className="d-md-none ms-auto">
          <span className="badge badge-light fs-7 b-radius px-3 py-2">
            {from}-{to} {ofLabel} {totalRows}
          </span>
        </div>

        {/* MOBILE flechas (fila inferior, centradas) */}
        <div className="d-md-none w-100 mt-2 d-flex justify-content-center gap-2">
          <button
            className={`btn btn-sm btn-icon ${isFirst ? 'opacity-50' : ''}`}
            disabled={isFirst}
            onClick={() => onChange('first')}
          >
            <Icon icon="bi-chevron-bar-left" {...getIconProps(isFirst)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isFirst ? 'opacity-50' : ''}`}
            disabled={isFirst}
            onClick={() => onChange('prev')}
          >
            <Icon icon="bi-chevron-left" {...getIconProps(isFirst)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isLast ? 'opacity-50' : ''}`}
            disabled={isLast}
            onClick={() => onChange('next')}
          >
            <Icon icon="bi-chevron-right" {...getIconProps(isLast)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isLast ? 'opacity-50' : ''}`}
            disabled={isLast}
            onClick={() => onChange('last')}
          >
            <Icon icon="bi-chevron-bar-right" {...getIconProps(isLast)} />
          </button>
        </div>

        {/* ================= DESKTOP ================= */}

        <div className="d-none d-md-flex align-items-center gap-2 ms-auto">
          <span className="badge badge-light fs-7 b-radius px-3 py-2">
            {from}-{to} {ofLabel} {totalRows}
          </span>

          <button
            className={`btn btn-sm btn-icon ${isFirst ? 'opacity-50' : ''}`}
            disabled={isFirst}
            onClick={() => onChange('first')}
          >
            <Icon icon="bi-chevron-bar-left" {...getIconProps(isFirst)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isFirst ? 'opacity-50' : ''}`}
            disabled={isFirst}
            onClick={() => onChange('prev')}
          >
            <Icon icon="bi-chevron-left" {...getIconProps(isFirst)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isLast ? 'opacity-50' : ''}`}
            disabled={isLast}
            onClick={() => onChange('next')}
          >
            <Icon icon="bi-chevron-right" {...getIconProps(isLast)} />
          </button>

          <button
            className={`btn btn-sm btn-icon ${isLast ? 'opacity-50' : ''}`}
            disabled={isLast}
            onClick={() => onChange('last')}
          >
            <Icon icon="bi-chevron-bar-right" {...getIconProps(isLast)} />
          </button>
        </div>
      </div>
    </nav>
  );
}
